export enum AssigneeNamePrefixEnum {
  User = 'user://',
  Group = 'group://'
}
